/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function range(start, end) {
    if (end == null) {
        // eslint-disable-next-line
        end = start;
        // eslint-disable-next-line
        start = 0;
    }
    if (end < start) {
        return [];
    }
    const len = end - start;
    const res = Array(len);
    for (let i = 0; i < len; i++) {
        res[i] = start + i;
    }
    return res;
}
